import React, { useState } from "react";
import classnames from "classnames";
import { RuneStaticData } from "./EditableFullRuneTree";
import { Rune } from "@outplayed/tooltips";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { useLanguage } from "@ugg/shared/hooks/use-language-hooks";

interface MajorRuneTreeProps {
  className?: string;
  patch?: string;
  ssr?: boolean;
  skip?: boolean;
  isMobile?: boolean;
  recRunes: RuneStaticData["rec_runes"];
}

type CondensedRuneTreeProps = Pick<MajorRuneTreeProps, "patch" | "ssr" | "skip"> & {
  runeId: number;
  activePerkId?: number;
  language?: string;
};

const CondensedRuneTree: React.FC<CondensedRuneTreeProps> = ({ runeId, activePerkId, patch, ssr, skip }) => {
  const { getRuneJSON, useRiotRunes } = getRiotAssetsContext();
  const [language] = useLanguage();
  const { data, loading, error } = useRiotRunes({ patch, ssr, skip });
  const runeJSON = getRuneJSON(runeId, { patch, language, optionalData: data || [] });

  return (
    <div className="flex flex-row justify-between items-center p-[6px] w-[244px] h-[48px] rounded-[6px] bg-[#191937]">
      <div className="flex items-center">
        <div className="flex items-center justify-center w-[36px] h-[36px] rounded-sm bg-[#11112a]">
          <Rune runeId={runeId} patch={patch} ssr={ssr} skip={skip} disableTooltip />
        </div>
        <div className="items-center ml-[6px] text-[14px] font-bold">
          <div className="pointer">{runeJSON.name}</div>
        </div>
      </div>
      {activePerkId && (
        <div className="flex items-center justify-center w-[36px] h-[36px] rounded-sm">
          <Rune runeId={activePerkId} patch={patch} ssr={ssr} skip={skip} disableTooltip />
        </div>
      )}
    </div>
  );
};

export const MajorRuneTree: React.FC<MajorRuneTreeProps> = ({ className, patch, ssr, skip, isMobile, recRunes }) => {
  const { primary_style: primaryStyle, sub_style: subStyle, active_perks: activePerks } = recRunes;

  return (
    <div className={classnames("rune-trees-container", className)}>
      <CondensedRuneTree runeId={primaryStyle} activePerkId={activePerks[0]} patch={patch} ssr={ssr} skip={skip} />
      <CondensedRuneTree runeId={subStyle} patch={patch} ssr={ssr} skip={skip} />
    </div>
  );
};
